<template>
	<p
		v-if="id"
		:style="[
			styled
				? 'border-radius: 40px; padding: 4px; padding-left: 8px; padding-right: 8px; width: fit-content; border: 2px; border-color: darkgray;'
				: '',
			color ? `background-color: ${color}` : '',
		]"
		style="display: flex; flex-wrap: wrap; gap: 8px"
	>
		<span v-if="prefix">{{ prefix }}</span>
		<span v-if="useTextInput && datatype">
			{{ attribute?.value }}
		</span>
		<span v-else-if="showAsButtons">
			{{
				symbolsStore.term({
					id: graphStore.descriptor.enumItem.byId(attribute?.value)?.refersTo,
					terminology: graphStore.descriptor.enumItem.byId(attribute?.value)?.terminology,
				})
			}}
		</span>
		<span v-else-if="!isArray">
			{{
				symbolsStore.term({
					id: graphStore.descriptor.enumItem.byId(displayedValue)?.refersTo,
					terminology: graphStore.descriptor.enumItem.byId(displayedValue)?.terminology,
				})
			}}
		</span>
		<span v-else v-for="val in arrayValue">
			{{
				symbolsStore.term({
					id: graphStore.descriptor.enumItem.byId(val)?.refersTo,
					terminology: graphStore.descriptor.enumItem.byId(val)?.terminology,
				})
			}}
		</span>
	</p>
	<p v-else>NO VALUE</p>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, onUnmounted } from "vue";
import { useGraphStore } from "../../../../store/graph";
import { DescriptorDatatype } from "@lr-notitia/notitia-operator/schemas";
import { useSymbolsStore } from "../../../../store/symbols";
import { watch } from "vue";

const compProps = defineProps({
	id: {
		type: String,
		default: null,
	},
	color: {
		type: String,
		default: null,
	},
	styled: {
		type: Boolean,
		default: false,
	},
	prefix: {
		type: String,
		default: null,
	},
	updatingComp: {
		type: Boolean,
		default: false,
	},
});

watch(
	() => compProps.updatingComp,
	() => {
		if (isArray && Array.isArray(attribute.value?.value)) {
			arrayValue.value = attribute.value?.value;
		}
	},
);

onMounted(() => {
	if (isArray && Array.isArray(attribute.value?.value)) {
		arrayValue.value = attribute.value?.value;
	}
});

const graphStore = useGraphStore();
const symbolsStore = useSymbolsStore();
const attribute = computed(() => {
	return graphStore.instance.attribute.byId(compProps.id);
});
const instanceAttribute = computed(() => {
	return graphStore.instance.attribute.byId(compProps.id);
});
const conceptAttribute = computed(() => {
	return graphStore.concept.attribute.byId(instanceAttribute.value?.concept || "");
});
const datatype = computed<DescriptorDatatype | undefined>(() => {
	return graphStore.descriptor.datatype.byId(conceptAttribute.value?.datatype || "");
});
const isArray = computed(() => datatype.value?.id === "array");

const showAsButtons = computed(() => {
	if (isArray) return false;
	if (!datatype) return false;
	if (!datatype.value?.enumerationItems.length) return false;
	return datatype.value.enumerationItems.length <= 5;
});

const useTextInput = computed(() => {
	return (
		datatype.value?.id === "date" ||
		datatype.value?.id === "time" ||
		datatype.value?.id === "timestamp" ||
		datatype.value?.id === "string" ||
		datatype.value?.id === "number"
	);
});

const arrayValue = ref<string[] | undefined>(undefined);
const displayedValue = computed(() => {
	if (Array.isArray(attribute.value?.value)) return undefined;
	if (attribute.value?.value === "undefined" || attribute.value?.value === "unknown") return undefined;
	return attribute.value?.value;
});
</script>
